import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UnityService } from 'src/app/services/unity.service';
import { Unity } from 'src/app/models/unity';
import { NgbModal, NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { UnitTypeService } from 'src/app/services/unit-type.service';
import { UnitType } from 'src/app/models/unit-type';
import { CustomerService } from 'src/app/services/customer.service';
import { Customer } from 'src/app/models/customer';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from "src/environments/environment";
import { ToastrManager } from 'ng6-toastr-notifications';
import { SapProject } from 'src/app/models/sap-project';
import { SapProjectService } from 'src/app/services/sap-project.service';
import { User } from 'src/app/models/user';
import { UserService } from 'src/app/services/user.service';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';

@Component({
  selector: 'app-unity-single',
  templateUrl: './unity-single.component.html',
  styleUrls: ['./unity-single.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class UnitySingleComponent implements OnInit {
  unity:Unity = new Unity();
  types:UnitType[];
  customers:Customer[];
  loading:boolean = false;

  editUnity:boolean = true;
  showUn:boolean = true;
  isMachinery:boolean = true;
  sapProjects:SapProject[] = [];
  users:User[] = [];
  img:string = '';
  files: {name:string, url:string, extension:string, icon:string}[] = [];
  //Archivos a Eliminar de la Unidad
  deleteSelectedFiles:string[] = [];

  @ViewChild('avatar') avatar;
  @ViewChild('file') file;

  constructor(private actRoute:ActivatedRoute, private unityServ:UnityService, private userServ:UserService, private modalService: NgbModal, private unitTypeServ:UnitTypeService, private customerServ:CustomerService, private utl:UtilitiesService, private authServ:AuthService, private toastr: ToastrManager, private projectServ:SapProjectService) { 
    this.actRoute.params.subscribe(params => {
      this.loading = true;
      this.isMachinery = (this.authServ.isExactly('machinery') || this.authServ.isExactly('staff'));

      this.unitTypeServ.getTypes().then(types => {
        if(this.isMachinery) {
          this.types = types.filter(x => x.id > 12);
        } else {
          this.types = types;
        }
      });
      this.customerServ.getCustomers('Compañia,Intercompañia').then(customers => this.customers = customers);
      this.unityServ.getUnity(params.id).then(unity => {
        this.unity = unity;

        if(this.isMachinery) {
          this.showUn = this.unity.user_id == this.authServ.getActualUser().id;
        }

        this.unity.insurance_expiration_date = this.unity.insurance_expiration_date ? new Date(this.unity.insurance_expiration_date + " 10:00:00") : this.unity.insurance_expiration_date;
        this.unity.insurance_issue_date = this.unity.insurance_issue_date ? new Date(this.unity.insurance_issue_date + " 10:00:00") : this.unity.insurance_issue_date;
        this.unity.physical_mechanics_date = this.unity.physical_mechanics_date ? new Date(this.unity.physical_mechanics_date + " 10:00:00") : this.unity.physical_mechanics_date;
        this.unity.pollutant_date = this.unity.pollutant_date ? new Date(this.unity.pollutant_date + " 10:00:00") : this.unity.pollutant_date;

        this.img = environment.baseUrl + '/unities/' + this.unity.id + '/avatar.jpg';

        this.userServ.getUsers().then(users => {
          this.users = users;
          this.loading = false;
        });
      });
    });
  }

  ngOnInit() {
    this.editUnity = this.authServ.can('update-unity');
    this.projectServ.getProjects().then(projects => this.sapProjects = projects);
  }

  show(content) {
    this.modalService.open(content, { size: 'lg', windowClass: 'bigger' });
  }

  getFiles() {
    this.loading = true;
    this.unityServ.getFiles(this.unity).then(resp => {
      this.files = resp.map(u => {
        let name = u.substring(u.lastIndexOf('/') + 1);
        let extension = name.substring(name.lastIndexOf('.') + 1);
        let url = environment.baseUrl + '/' + u;
        let icon = 'fa fa-file-' + (extension == 'pdf' ? 'pdf' : 'image');
        return {name, extension, url, icon};
      });
      this.loading = false;
    }, error => {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
    });
  }

  saveFile() {
    if (this.file.nativeElement.files) {
      this.loading = true;
      let file = this.file.nativeElement.files[0];
      if(!this.files.find(e => e.name === file.name))
      {
        const formData: FormData = new FormData();
        formData.append('file', file, file.name);

        this.unityServ.postFile(this.unity, formData).then(x => {
          this.loading = false;
          this.toastr.successToastr("El archivo se ha guardado correctamente");
        }, error => {
          this.loading = false;
          this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
        });
      }else{
        this.loading = false;
        this.toastr.infoToastr("Ya existe un archivo con el mismo nombre y extensión en la plataforma, renombra el archivo o selecciona otro.");
      }
    }
  }

  async update(event) {
    try {
      event.preventDefault();
      
      this.loading = true;
      let resp = await this.unityServ.putUnity(this.unity);
      
      resp.insurance_expiration_date = resp.insurance_expiration_date ? new Date(resp.insurance_expiration_date) : resp.insurance_expiration_date;
      resp.insurance_issue_date = resp.insurance_issue_date ? new Date(resp.insurance_issue_date) : resp.insurance_issue_date;
      resp.physical_mechanics_date = resp.physical_mechanics_date ? new Date(resp.physical_mechanics_date) : resp.physical_mechanics_date;
      resp.pollutant_date = resp.pollutant_date ? new Date(resp.pollutant_date) : resp.pollutant_date;

      this.unity = resp;
      
      this.modalService.dismissAll();
      this.loading = false;
      this.toastr.successToastr('La unidad se ha actualizado correctamente', '', {enableHTML: true});
    } catch(e) {
      this.toastr.errorToastr(this.utl.formatMessages(e), '', { enableHTML: true });
      this.loading = false;
    }
  }

  addFile() {
    if (this.avatar.nativeElement.files) 
    {
      this.loading = true;
      let file = this.avatar.nativeElement.files[0];

      const formData: FormData = new FormData();
      formData.append('avatar', file, file.name);

      this.unityServ.postAvatar(this.unity, formData).then( response => {
        this.unity = response;
        this.img = environment.baseUrl + '/unities/' + this.unity.id + '/avatar.jpg';
        this.loading = false;
        this.unity.image = true;

        let message = this.unity.image ? 'actualizada' : 'subida';
        this.toastr.successToastr('Imagen ' + message + ' correctamente', '', {enableHTML: true});
      }, error => {
        this.loading = false;
        this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
      });
    }else{
      this.toastr.infoToastr('Debes cargar una imagen válida', '', {enableHTML: true});
    }
  }

  deleteFiles(){
    this.loading = true;
    this.unityServ.deleteUnityFiles(this.unity, this.deleteSelectedFiles).subscribe( response => {
      this.loading = false;
      this.deleteSelectedFiles = [];
      this.modalService.dismissAll();
      this.toastr.successToastr('Los archivos seleccionados fueron eliminados correctamente', '', {enableHTML: true});
    }, error => {
      this.loading = false;
      this.deleteSelectedFiles = [];
      this.modalService.dismissAll();
      this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
    });
  }

  selectedUnityFiles(f){
    if(!this.deleteSelectedFiles.includes(f)){
      this.deleteSelectedFiles.push(f);
    }else{
      let i = this.deleteSelectedFiles.indexOf(f);
      if(i !== -1){
        this.deleteSelectedFiles.splice(i, 1);
      }
    }
  }
}
